import React, { useState } from 'react';
import '../../Navbar.css';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setOpen(!open);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <>
      <nav className="navbar-joinstack d-flex align-items-center justify-content-between px-3 py-3">
        <div className="d-flex align-items-center gap-2">
          <a href="/dashboard" className="navbar-logo">JOINSTACK</a>
        </div>
        <button className="hamburger d-md-none" onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </button>
        <div className="navbar-links d-none d-md-flex gap-4 align-items-center">
          <a href="/dashboard">Dashboard</a>
          <a href="/websites">Website-uri</a>
          <a href="/clients">Clienți</a>
          <a href="/invoices">Facturi</a>
          <a href="#">Activitate / Logs</a>
          <a href="/convert">Convertor fisiere</a>
          <a href="#">Setări</a>
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </nav>

      {/* Mobile overlay menu */}
      {open && (
        <div className="mobile-menu">
          <div className="mobile-inner">
            <a href="/dashboard">Dashboard</a>
            <a href="/websites">Website-uri</a>
            <a href="/clients">Clienți</a>
            <a href="/invoices">Facturi</a>
            <a href="#">Activitate / Logs</a>
            <a href="/convert">Convertor fisiere</a>
            <a href="#">Setări</a>
            <button className="logout-btn mt-4" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
